type TModalBodyProps = {
  children: React.ReactNode
  id?: string
} & Partial<React.HTMLAttributes<HTMLDivElement>>

export function ModalBody({ children, id, ...rest }: TModalBodyProps) {
  return (
    <div
      {...rest}
      data-testid={id}
      className="border-[#e6e6e6] border-t-none border-r-quarterpulse border-b-none border-l-quarterpulse bg-[#FFF] pt-fourpulse pr-fourpulse pb-fourpulse pl-fourpulse"
    >
      {children}
    </div>
  )
}
